module.exports = __webpack_public_path__ + "static/abdolmalekico-cover-13fb882a216a518918b9db00faf225f8.jpg";